import React from "react";

const OpenMail = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <path
          className="u_fill"
          d="M2.389 11.175L17.184 2.23a1.59 1.59 0 011.646 0l14.781 8.947a.804.804 0 01.389.692v20.517c0 .428-.169.839-.469 1.141-.3.303-.707.473-1.131.473H3.6c-.424 0-.831-.17-1.131-.473A1.62 1.62 0 012 32.387v-20.52a.812.812 0 01.389-.692zm25.765 2.243l-10.056 8.776-10.263-8.786-2.07 2.46 12.352 10.576 12.13-10.585-2.093-2.441z"
          fill={fill}
      />
    </svg>
);

export default OpenMail;